// src/store/authSlice.ts
//added to manage authentication state
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { itwApi } from '../../api/middlewares/api';
function mapUserinfo(response) {
    const roles = response.rawClaims.filter((c) => c.type === 'groups').map((c) => c.value);
    const claims = {};
    for (const claim of response.rawClaims) {
        const key = claim.type;
        if (!claims[key])
            claims[key] = [];
        claims[key].push(claim.value);
    }
    return {
        username: response.username,
        name: response.name,
        email: response.email,
        roles,
        claims
    };
}
export const fetchUser = createAsyncThunk('auth/fetchUser', async () => {
    const res = await itwApi.get('/users/userinfo');
    return mapUserinfo(res.data);
});
const initialState = {
    isAuthenticated: false,
    loading: false,
    user: null,
    hasCheckedSession: false
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.user = null;
            state.isAuthenticated = false;
            state.hasCheckedSession = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
            state.loading = true;
        })
            .addCase(fetchUser.fulfilled, (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
            state.loading = false;
            state.hasCheckedSession = true;
        })
            .addCase(fetchUser.rejected, (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.loading = false;
            state.hasCheckedSession = true;
        });
    }
});
export const { logout } = authSlice.actions;
export default authSlice.reducer;
